import { httpClient } from "@/lib/http-client"

export class Area {
  constructor(id: string, name: string, siteId: string, description: string | null) {
    this.id = id
    this.name = name
    this.description = description
    this.siteId = siteId
  }

  id: string
  name: string
  description: string | null
  siteId: string
}

export class AreaService {
  private static readonly BASE_PATH = "/api/areas"

  static create(action: Area): Promise<Area> {
    return httpClient
      .post<Area>(`${this.BASE_PATH}`, action)
  }

  static getBySiteId(siteId: string): Promise<Area[]> {
    return httpClient
      .get<Area[]>(`${this.BASE_PATH}/site/${siteId}`)
  }

  static getById(actionId: string): Promise<Area> {
    return httpClient
      .get<Area>(`${this.BASE_PATH}/${actionId}`)
  }

  static update(actionId: string, action: Area): Promise<Area> {
    return httpClient
      .put<Area>(`${this.BASE_PATH}/${actionId}`, action)
  }

  static delete(areaId: string): Promise<void> {
    return httpClient
      .delete(`${this.BASE_PATH}/${areaId}`)
  }
}